<template>
	<section id="view-detalhes-produto" v-if="produto">
		<div class="section">
			<div class="banner-desktop mb-4" v-if="banners.PRODUCT_BANNERS">
				<div v-for="b in banners.PRODUCT_BANNERS" :key="b.id">
					<img :src="b.src" />
				</div>
			</div>
			<div class="banner-mobile mb-4" v-if="banners.PRODUCT_BANNERS_MOBILE">
				<div v-for="b in banners.PRODUCT_BANNERS_MOBILE" :key="b.id">
					<img :src="b.src" />
				</div>
			</div>
		</div>
		<div class="section section__top">
			<ais-instant-search :search-client="searchClient" :index-name="indexNameProdutos">
				<div class="ais-SearchBox">
					<form @submit.prevent class="ais-SearchBox-form" novalidate>
						<input class="ais-SearchBox-input" @keyup.enter="tryRefine(query)" v-model="query" type="search" placeholder="Não encontrou seu produto? Busque aqui..." />
						<button class="lupa-busca" @click="tryRefine(query)">
							<img :src="`/custom/loja/assets/media/icons/lupa-primaria.svg`" />
						</button>
					</form>
				</div>
			</ais-instant-search>

			<div style="overflow: scroll">
				<div class="flex" style="min-width: max-content">
					<Breadcrumb :departamento="produto.departamento" :grupo="produto.grupo" :secao="produto.secao" class="breadcrumb__product hidden lg1220:flex mt-4 vw-head-light"></Breadcrumb>
				</div>
			</div>

			<h1 class="lg1220:hidden product__name color-grey-3c mt-2">{{ productName }}</h1>
			<div class="lg1220:hidden head-regular product__application color-grey-6a" v-if="productApplicationsText">
				Compatibilidade: <span class="head-bold color-grey-3c">{{ productApplicationsText }}</span>
			</div>
			<div class="lg1220:hidden head-regular product__application color-grey-6a mt-1">
				Unidade de venda: <span class="head-bold color-grey-3c">{{ produto.unidade_venda }}</span>
			</div>
		</div>
		<div class="container-grupo-foto-infos-produto">
			<div class="product__leftside">
				<div class="img__carousel">
					<div class="hidden lg1220:flex glide-vertical">
						<button @click="changeSlide(0)" class="vertical__box" v-if="produto.fotos.fotos_360.length > 0">
							<img :src="getImgSrc(produto.fotos.fotos_360[0])" alt="" />
						</button>
						<button @click="changeSlide($i + fotos360HelperIndex)" class="vertical__box" v-for="(img, $i) in produto.fotos.fotos_avulsas" :key="$i">
							<img :src="getImgSrc(img)" alt="" />
						</button>
					</div>
					<div class="glide__wrapper">
						<div class="glide glide-product">
							<div data-glide-el="track" class="glide__track">
								<ul class="glide__slides">
									<li v-if="produto.fotos.fotos_360.length === 0 && produto.fotos.fotos_avulsas.length === 0 && produto.fotos.fotos_crop.length === 0">
										<img :src="getImgSrc()" @contextmenu="handlerContextMenu($event)" :alt="productName" />
									</li>
									<li v-if="produto.fotos.fotos_360.length > 0">
										<ComponentDetalheImagens360 :fotos="produto.fotos.fotos_360"></ComponentDetalheImagens360>
									</li>

									<li v-for="(photo, i) in produto.fotos.fotos_avulsas" :key="i">
										<div class="icon__zoom">
											<img class="zoom-lupa" src="@/assets/icons/lupa-zoom.svg" alt="Zoom Lupa" />
										</div>

										<figure class="zoom" @mousemove="zoom($event)" :style="`background-image: url('${getImgSrc(photo)}')`">
											<img :src="getImgSrc(photo)" @contextmenu="handlerContextMenu($event)" :alt="productName" />
										</figure>
									</li>
									<li v-for="(photo, i) in produto.fotos.fotos_crop" :key="i">
										<div class="icon__zoom">
											<img class="zoom-lupa" src="@/assets/icons/lupa-zoom.svg" alt="Zoom Lupa" />
										</div>
										<figure class="zoom" @mousemove="zoom($event)" :style="`background-image: url('${getImgSrc(photo)}')`">
											<img :src="getImgSrc(photo)" :alt="productName" />
										</figure>
									</li>
								</ul>
								<div class="glide__bullets" data-glide-el="controls[nav]">
									<button v-for="(d, $d) in getTotalOfAvailablePhotos" :key="$d" class="glide__bullet" :data-glide-dir="`=${$d}`"></button>
								</div>
								<div class="glide__arrows" data-glide-el="controls" v-if="getTotalOfAvailablePhotos > 1">
									<button class="glide__arrow glide__arrow--left" data-glide-dir="<"><i class="fas fa-chevron-left"></i></button>
									<button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i class="fas fa-chevron-right"></i></button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Relacionados -->
				<h3 v-if="produtosRelacionados && produtosRelacionados.length > 0" class="color-grey-3c mb-4">Monte seu kit</h3>
				<div class="relacionados" v-if="produtosRelacionados && produtosRelacionados.length > 0">
					<ProductListItem
						v-for="(produto, produtoIndex) in produtosRelacionados"
						:key="'card-produto-' + produto.id_produto"
						:produto="produto"
						:produtoIndex="produtoIndex"
						@linkCardProdutoClick="linkCardProdutoClick"
						:availableStores="availableStores"
						:geolocation="geolocation"
					/>
				</div>
			</div>

			<div class="product__rightside">
				<client-only>
					<div class="container-infos-produto">
						<div class="product__info">
							<h1 class="product__name color-grey-3c hidden lg1220:block">{{ productName }}</h1>
							<div class="hidden lg1220:block applications__text head-regular" v-if="productApplicationsText">
								Compatibilidade: <span class="head-bold">{{ productApplicationsText }}</span>
							</div>
							<div class="hidden lg1220:block applications__text head-regular mt-1">
								Unidade de venda: <span class="head-bold">{{ produto.unidade_venda }}</span>
							</div>
						</div>

						<div class="bloco-compra">
							<div v-if="hasSizes" class="sh-16"></div>

							<Select style="max-width: 173px" v-if="hasSizes" @setValue="setSize" :data="tamanhos" :active="produto.id_produto_variacao"></Select>

							<div v-if="hasSizes" class="sh-16"></div>

							<div class="container-texto-sem-estoque static-mb-16" v-if="solicitarCotacao && !isClone">
								<span class="head-regular grey400 font-24">Produto temporariamente esgotado. Em breve estará disponível novamente.</span>
							</div>

							<div class="container-texto-sem-estoque static-mb-16" v-if="Object.keys(checkPriority).length === 0 && isClone">
								<span class="head-regular grey400 font-24">Produto temporariamente esgotado. Em breve estará disponível novamente.</span>
							</div>

							<ProductPriceRange v-if="possuiPrecoRange && !selecionouCidade && !isClone" :lowPrice="produto.preco_low" :highPrice="produto.preco_high" :quantity="produto.qtde_lojas" priceFeatured noMarginBottom class="productpage__price" />

							<ProductPrice
								v-if="mostrarPreco && Object.keys(checkPriority).length !== 0 && checkPriority.estoque_disponivel > 0 && !isClone"
								:finalPrice="checkPriority.preco_final"
								:majorPrice="checkPriority.preco_majorado"
								:discountPrice="checkPriority.preco_desconto"
								:discount="checkPriority.desconto"
								:geolocation="geolocation"
								:dealerUf="checkPriority.uf"
								:showParcelas="true"
								:maximoParcelas="maximoParcelas"
								:parcelaData="parcelaData"
								:multiplasConcessionarias="multiplasConcessionarias"
								@botaoFornecidoPorEscolherOutraConcessionariaClick="botaoFornecidoPorEscolherOutraConcessionariaClick"
							/>
						</div>

						<!-- Ações de Comprar, Adicionar o carrinho -->

						<!-- 1- com/sem localização e produto sem estoque: avise-me (marketplace) -->
						<div v-if="(!produto.stock_enable && !isClone) || (Object.keys(produto.availability).length === 0 && !isClone)">
							<button @click.prevent.stop="abrirModalSolicitarCotacao(produto.id, produto)" class="btn__primary--outline head-regular">Avise-me quando chegar!</button>
						</div>

						<!-- 1- com/sem localização e produto sem estoque: avise-me (loja conc) -->
						<div v-if="Object.keys(checkPriority).length === 0 && isClone" class="hidden lg1220:block mt-4">
							<button @click.prevent.stop="abrirModalSolicitarCotacao(produto.id, produto)" class="btn__primary--outline head-regular">Avise-me quando chegar!</button>
						</div>

						<!-- 2- com localização e produto com estoque: comprar / carrinho -->
						<div v-if="selecionouCidade && checkPriority.estoque_disponivel > 0">
							<div class="mb-4 flex flex-column gap-3">
								<button @click="botaoComprarClick(true)" style="min-height: 48px" class="btn__primary head-regular w-100" :disabled="limitCart">Comprar</button>
							</div>
						</div>

						<ProductProvidedBy
							v-if="productWithStock && !isClone"
							:qtdLojas="produto.qtde_lojas"
							:locationSelected="selecionouCidade"
							:soldBy="checkPriority.vendido_por"
							:soldByDistance="activeDealershipDistance"
							@botaoFornecidoPorInformeOCepClick="botaoFornecidoPorInformeOCepClick"
							@botaoFornecidoPorEscolherOutraConcessionariaClick="botaoFornecidoPorEscolherOutraConcessionariaClick"
							:multiplasConcessionarias="multiplasConcessionarias"
							:dadosConcessionariaAtiva="dadosConcessionariaAtiva"
						></ProductProvidedBy>

						<ul class="flex flex-column gap-2 mt-3 mb-3">
							<div class="head-regular applications__text flex gap-2" style="font-size: 14px">
								<img src="/custom/loja/assets/media/icons/logo-header.svg" style="height: 20px" alt="Logotipo" />
								Peças Originais KTM
							</div>
							<div class="head-regular applications__text flex gap-1" style="font-size: 14px">
								<svg role="img" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" class="mr-1">
									<path
										d="M19.67 2.177a29.766 29.766 0 0 1-7.23-.89l-.44-.11-.44.11a29.766 29.766 0 0 1-7.23.89A1.33 1.33 0 0 0 3 3.507v8.509a8.506 8.506 0 0 0 3.285 6.716l4.9 3.81a1.328 1.328 0 0 0 1.634 0l4.9-3.81A8.506 8.506 0 0 0 21 12.016V3.507a1.33 1.33 0 0 0-1.33-1.33zm0 9.839a7.131 7.131 0 0 1-2.77 5.666L12 21.493l-4.9-3.811a7.131 7.131 0 0 1-2.77-5.666V3.507a31.168 31.168 0 0 0 7.553-.929l.117-.03.117.03a31.168 31.168 0 0 0 7.553.929zm-8.72-.488 4.112-4.113.938.941-5.05 5.053L8 10.456l.941-.941z"
									></path>
								</svg>
								Garantia de 3 meses de fábrica
							</div>
						</ul>

						<hr style="margin-top: 24px; margin-bottom: 16px" />

						<ProductFrete
							v-if="featuresJson.SELLER && mostrarPreco && Object.keys(checkPriority).length !== 0 && checkPriority.estoque_disponivel > 0"
							v-model="freteValue"
							@click="calculateShipping"
							@changeCEP="changeCEP"
							:fretes="fretes"
							:loading="loadingFrete"
							:error="errorFrete"
						></ProductFrete>

						<Modal :visibility="notificationTooltip" @closeModal="notificationTooltip = !notificationTooltip" width="448" class="modal__cart">
							<div style="display: flex; gap: 4px; align-items: center" class="mb-3 head-bold text-primary">
								<svg id="_24px_shopping_cart" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
									<path
										data-name="shopping cart"
										d="M12.686,19.535a.761.761,0,1,1,.761.76A.735.735,0,0,1,12.686,19.535Zm-9.13,0a.734.734,0,0,1,.761-.761.761.761,0,1,1,0,1.522A.734.734,0,0,1,3.557,19.535ZM2.8,17.765v-1.33H14.171l.846-3.54H2.49a.666.666,0,0,1-.65-.526L.014,3.849a.665.665,0,0,1,.651-.806H17.371l.6-2.532A.662.662,0,0,1,18.622,0h3.043V1.33H19.146L15.341,17.254a.662.662,0,0,1-.646.511Zm.233-6.2H15.335l1.717-7.191H1.488Zm8.995-1.617V5.991h1.329V9.948Zm-3.35,0V5.991H10V9.948Zm-3.348,0V5.991h1.33V9.948Z"
										transform="translate(1.366 2.704)"
										fill="#ff6600"
									></path></svg
								>Produto adicionado no carrinho com sucesso.
							</div>
							<div class="flex flex-column gap-3">
								<button @click="notificationTooltip = !notificationTooltip" style="min-height: 48px" class="btn__primary--outline head-regular w-100 small">Continuar comprando</button>
								<button @click="$router.push({ path: '/checkout/carrinho' })" style="min-height: 48px" class="btn__primary head-regular small" :disabled="limitCart">Ver carrinho</button>
							</div>
						</Modal>
					</div>
				</client-only>
			</div>
		</div>

		<!-- Tabs -->
		<div class="product__tabs mt-3">
			<div class="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
				<ul class="flex flex-wrap -mb-px">
					<li class="mr-2">
						<a
							href.prevent="#"
							style="cursor: pointer"
							@click="tabAtiva = 'descricao'"
							class="inline-block p-4 border-b-2 border-transparent dark:hover:text-gray-300 head-bold"
							:class="{ 'text-blue-600 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500': tabAtiva === 'descricao' }"
							><h3>Descrição</h3></a
						>
					</li>
					<li class="mr-2">
						<a
							href.prevent="#"
							style="cursor: pointer"
							@click="tabAtiva = 'caracteristicas'"
							class="inline-block p-4 border-b-2 border-transparent rounded-t-lg active dark:text-blue-500 dark:border-blue-500 head-bold"
							:class="{ 'text-blue-600 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500': tabAtiva === 'caracteristicas' }"
							aria-current="page"
							><h3>Características</h3></a
						>
					</li>
					<li class="mr-2">
						<a
							href.prevent="#"
							style="cursor: pointer"
							@click="tabAtiva = 'aplicacoes'"
							class="inline-block p-4 border-b-2 border-transparent dark:hover:text-gray-300 head-bold"
							:class="{ 'text-blue-600 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500': tabAtiva === 'aplicacoes' }"
							><h3>Aplicações</h3></a
						>
					</li>
				</ul>
			</div>

			<div id="default-tab-content">
				<div class="p-4 rounded-lg bg-gray-50 dark:bg-gray-800" style="background-color: #f1f1f1" :class="{ hidden: tabAtiva !== 'descricao' }" role="tabpanel" aria-labelledby="profile-tab">
					<p class="head-regular py-0" style="color: #3c484d">
						{{ produto.comentario }}
					</p>
				</div>
				<div class="p-4 rounded-lg bg-gray-50 dark:bg-gray-800" style="background-color: #f1f1f1" :class="{ hidden: tabAtiva !== 'caracteristicas' }" role="tabpanel" aria-labelledby="dashboard-tab">
					<ProductFeatures :summaryFeatures="produto.caracteristicas"></ProductFeatures>
				</div>
				<div class="p-4 rounded-lg bg-gray-50 dark:bg-gray-800" style="background-color: #f1f1f1" :class="{ hidden: tabAtiva !== 'aplicacoes' }" role="tabpanel" aria-labelledby="settings-tab">
					<ProductApplications :applicationsQuantity="produto.qtde_aplicacoes" :summaryApplications="produto.resumo_aplicacao"></ProductApplications>
				</div>
			</div>
		</div>

		<div class="container-arrow-down" v-if="mostrarArrowDown">
			<img src="/custom/epeca/assets/img/icone-arrow-down.svg" alt="" @click="iconeArrowDownClick" />
		</div>

		<Modal :visibility="modalVisibility" @closeModal="closeModal" width="448" class="modal__conc">
			<DealershipFilter
				:dealerships="dealerships"
				:filter="dealershipFilter"
				:loading="loadingDealerships"
				:error="dealershipError"
				@changeFilter="changeFilter"
				@changeDealership="changeDealership"
				:productName="produto.descricao"
				:images="produto.fotos"
				:activeDealership="checkPriority.id_loja"
			></DealershipFilter>
		</Modal>

		<NotificationTooltip :visibility="changeDealerTooltip">
			<div style="display: flex; gap: 4px; align-items: center">Você alterou a loja, verifique o novo preço e simule o novo frete.</div>
		</NotificationTooltip>

		<Modal :visibility="modalSolicitarCotacaoVisibility" width="623" @closeModal="modalSolicitarCotacaoVisibility = false">
			<ProductSolicitarCotacao @triggerSolicitarCotacao="triggerSolicitarCotacao" :productData="produto" />
		</Modal>

		<Modal :visibility="modalLimitVisibility" @closeModal="closeModalLimit" width="623">
			<div class="flex flex-column align-items-center static-mt-24">
				<div class="head-regular font-20 static-mb-32 static-mt-32 text-center">Você atingiu o limite de peças adquiridas em uma única compra. Caso deseje comprar mais itens, conclua a compra atual e inicie uma nova.</div>
				<button class="btn__primary" @click="$router.push({ name: 'checkout-carrinho' })">Ir para o carrinho</button>
			</div>
		</Modal>
	</section>
</template>

<script>
// Utils
import { getProductUrl, getLastPath } from "@/utils/route"
import { getDealershipsText, getBadgeText, getProductSizes } from "@/utils/product"
import { setAvailableStores, checkProductAvailability } from "@/utils/availability"

// Plugins
import Glide, { Controls, Breakpoints, Swipe } from "@glidejs/glide/dist/glide.modular.esm"
import { TheMask } from "vue-the-mask"
import { getDistance } from "geolib"
import algoliasearch from "algoliasearch"
import { mapGetters } from "vuex"

// Components
import Badge from "@/components/atoms/Badge"
import Breadcrumb from "@/components/Common/Breadcrumb"
import ComponentDetalheImagens360 from "~/components/ComponentDetalheImagens360"
import DealershipFilter from "@/components/Dealership/DealershipFilter"
import FeaturedText from "@/components/atoms/FeaturedText"
import Modal from "@/components/Common/Modal"
import NotificationTooltip from "@/components/Common/NotificationTooltip"
import ProductPriceRange from "@/components/Product/ProductPriceRange"
import ProductPrice from "@/components/Product/ProductPrice"
import ProductPriceClone from "@/components/Product/ProductPriceClone"
import ProductApplications from "@/components/Product/ProductApplications"
import ProductFeatures from "@/components/Product/ProductFeatures"
import ProductFrete from "@/components/Product/ProductFrete"
import ProductProvidedBy from "@/components/Product/ProductProvidedBy"
import ProductSolicitarCotacao from "@/components/Product/ProductSolicitarCotacao"
import ProductSizes from "@/components/Product/ProductSizes"
import Select from "@/components/atoms/Select"
import Tag from "@/components/atoms/Tag"
import TagGroup from "@/components/molecules/TagGroup"
import ProductListItem from "@/components/Product/ProductListItem"

// Mixins
import productMixin from "@/mixins/product"

import { required, minLength } from "vuelidate/lib/validators"

import { AisInstantSearch, AisSearchBox } from "vue-instantsearch"

const API_B2C_BACKEND = process.env.API_B2C_BACKEND
const ALGOLIA_INDEX_PRODUCTS = process.env.ALGOLIA_INDEX_PRODUCTS
let TOKEN_EPA = process.env.TOKEN_EPA

async function carregarProdutoPorId(productIds, indexProdutos, defaultStoreId) {
	let ret = {}

	let arrStringFilters = []
	let stringFilters = `({FILTER_ITEMS})`

	productIds.forEach((item) => {
		arrStringFilters.push(`id_produto=${item} OR `)
	})

	if (arrStringFilters.length > 0) {
		arrStringFilters[arrStringFilters.length - 1] = arrStringFilters[arrStringFilters.length - 1].replace(" OR ", "")

		stringFilters = stringFilters.replace("{FILTER_ITEMS}", arrStringFilters.join(""))

		ret = await indexProdutos.search(
			"",
			{
				filters: stringFilters,
				optionalFilters: `${setAvailableStores(defaultStoreId)}`,
			},
			{}
		)
	}

	return ret
}

async function carregarProduto(idProduto, indexProdutos, defaultStoreId) {
	// Busca os dados da concessionaria pelo getObject
	const res = await indexProdutos.getObject(String(idProduto))
	return res
}

async function carregarProdutoHits(idProduto, indexProdutos, defaultStoreId) {
	let ret = {}

	idProduto = parseInt(idProduto)

	ret = await indexProdutos.search(idProduto, {
		clickAnalytics: true,
		filters: `id_produto:${idProduto}`,
		distinct: false,
		typoTolerance: false,
		attributesToRetrieve: ["*", "-ano", "-categoria_hierarquical", "-ano_de", "-ano_ate"],
		optionalFilters: `${setAvailableStores(defaultStoreId)}`,
	})

	return ret
}

function chassiInvalido(chassi) {
	return /([iI]+|[oO]+|[qQ]+|^([a-zA-Z0-9]){11}(?=.*[a-zA-Z]))/g.test(chassi)
}

const checarChassiInvalido = (value) => chassiInvalido(value)

export default {
	mixins: [productMixin],
	props: [],
	components: {
		AisInstantSearch,
		AisSearchBox,
		TheMask,
		FeaturedText,
		ProductSizes,
		ProductPriceRange,
		ProductPrice,
		ProductPriceClone,
		ProductApplications,
		ProductFeatures,
		ProductProvidedBy,
		ProductSolicitarCotacao,
		Modal,
		DealershipFilter,
		Tag,
		TagGroup,
		Select,
		Badge,
		ProductFrete,
		Breadcrumb,
		NotificationTooltip,
		ComponentDetalheImagens360,
		ProductListItem,
	},
	async asyncData({ app, route, store }) {
		const searchClient = algoliasearch(app.$epecaHubB2c.configJson.ALGOLIA_APPLICATION_ID, app.$epecaHubB2c.configJson.ALGOLIA_API_KEY_READ_ONLY)
		const indexNameProdutos = process.env.ALGOLIA_INDEX_PRODUCTS

		const indexProdutos = searchClient.initIndex(indexNameProdutos)

		const routePath = route.path
		const idProdutoRoute = routePath.replace("/produto/", "").split("/")[0]

		const productId = getLastPath(routePath) || idProdutoRoute

		let defaultStoreId = []

		if (app.$epecaHubB2c.configJson.DEFAULT_STORE_ID) {
			defaultStoreId = app.$epecaHubB2c.configJson.DEFAULT_STORE_ID.split(",")
		}

		if (app.store.state.availableStores.length > 0) {
			defaultStoreId = app.store.getters["availableStores"]
		}

		let availableStores = app.$cookies.get("availableStores")

		const produtoAlgolia = await carregarProduto(productId, indexProdutos, defaultStoreId)

		const queryID = produtoAlgolia.queryID

		let relacionados = []
		if (produtoAlgolia.userData && produtoAlgolia.userData[0].relacionados) {
			relacionados = produtoAlgolia.userData[0].relacionados
		}

		let uniqProducts = []
		let mapProducts = new Map()

		let produto
		// Regra para collection
		if (produtoAlgolia.segmento === "Boutique") {
			const produtoComVariacoes = await carregarProdutoHits(productId, indexProdutos, defaultStoreId)
			for (const iterator of produtoComVariacoes.hits) {
				if (!mapProducts.has(iterator.id_produto_variacao)) {
					mapProducts.set(iterator.id_produto_variacao, true)
					uniqProducts.push({
						id_produto_variacao: iterator.id_produto_variacao,
						...iterator,
					})
				}
			}
			produto = produtoComVariacoes.hits[0]
		} else {
			produto = produtoAlgolia
		}

		const produtos = uniqProducts

		let tamanhos = []

		tamanhos = getProductSizes(availableStores, produtos)

		if (produto.segmento !== "Boutique") {
			tamanhos = []
		}

		let productImage = produto.fotos.fotos_360[0] || produto.fotos.fotos_avulsas[0] || produto.fotos.fotos_crop[0] || null

		let productImageUrl = `${app.$epecaHubB2c.configJson.CDN_IMAGES_RESIZE}/900x900/${productImage}`

		let hasStock = produto.stock_enable

		const structuredData = {
			"@context": "https://schema.org",
			"@type": "Product",
			name: produto.seo_title,
			image: productImageUrl,
			description: produto.descricao_secundaria,
			sku: produto.codigobarras.toString().replace(",", ", "),
			mpn: produto.codigosoriginais.toString().replace(",", ", "),
			offers: {
				"@type": "Offer",
				availability: hasStock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
				price: produto.preco_avg,
				priceCurrency: "BRL",
			},
		}

		const metaProdutos = [
			{
				property: "og:site_name",
				hid: "og:site_name",
				content: app.$epecaHubB2c.configJson.SEO_DEFAULT_TITLE,
			},
			{ property: "og:type", content: "og:product" },
			{ property: "og:title", content: produto.seo_title },
			{ property: "product:plural_title", content: produto.seo_title },
			{
				name: "twitter:site",
				content: app.$epecaHubB2c.configJson.SEO_DEFAULT_TITLE,
			},
			{ name: "twitter:card", content: "summary_large_image" },
			{
				hid: "twitter:url",
				name: "twitter:url",
				content: app.$epecaHubB2c.configJson.SEO_DEFAULT_TITLE,
			},
			{
				hid: "twitter:title",
				name: "twitter:title",
				content: produto.seo_title,
			},
			{
				hid: "twitter:description",
				name: "twitter:description",
				content: produto.seo_title,
			},
			{
				hid: "twitter:image",
				name: "twitter:image",
				content: productImageUrl,
			},
		]

		// let selecionouCidade = false;
		if (app.$cookies.get("selectedCity")) {
			// selecionouCidade = true;
			let geolocation = app.$cookies.get("geolocation")
			store.dispatch("definirCidadeSelecionada", geolocation.cidade)
		}

		// What should be rendered before SSR load
		// selecionouCidade ? on : off -> Ok
		// availableStores ? true : false -> Ok from cookie
		// checkPriority ? true : false

		return {
			tamanhos,
			produtos,
			produto,
			structuredData,
			metaProdutos,
			defaultStoreId,
			relacionados,
			indexNameProdutos,
			queryID,
		}
	},
	data() {
		const produto = {}
		const structuredData = {}
		const metaProdutos = []

		return {
			tabAtiva: "descricao",
			chassi: "",
			requestChassi: false,
			loadingRequestChassi: false,
			listaPerguntas: [],
			query: "",
			searchClient: algoliasearch(this.$epecaHubB2c.configJson.ALGOLIA_APPLICATION_ID, this.$epecaHubB2c.configJson.ALGOLIA_API_KEY_READ_ONLY),
			dadosConcessionariaAtiva: null,
			produtosRelacionados: [],
			glide: null,
			geolocation: null,
			fretes: [],
			loadingFrete: false,
			errorFrete: "",
			modalLimitVisibility: false,
			modalSolicitarCotacaoVisibility: false,
			limitCart: false,
			modalVisibility: false,
			changeDealerTooltip: false,
			dealerships: [],
			dealershipFilter: "menor_valor_do_item",
			dealershipError: "",
			activeDealershipDistance: null,
			loadingDealerships: false,
			concessionarias: {
				carregando: false,
				data: [],
				registrosLimite: 4,
			},
			componentSelecaoConcessionariaCompra: {
				concessionariaSelecionada: null,
				show: false,
			},
			freteValue: null,
			frete: {
				carregando: false,
				erro: false,
				detalhes: [],
				mensagem: null,
				model: {
					cep: "",
				},
			},

			precoEstoque: {
				carregando: false,
				data: null,
			},

			produto,

			botaoEncontrarConcessionaria: {
				ativo: false,
			},

			formasPagamento: [],

			mostrarArrowDown: true,

			tamanhoSelecionado: null,
			listaProdutosCategoria: [],
			titleProdutosCategoria: "",
			parcelaData: null,
			notificationTooltip: false,
			modalCompatibilidadeVisibility: false,
			chassiError: "",
		}
	},
	validations: {
		chassi: {
			required,
			minLength: minLength(17),
			checarChassiInvalido,
		},
	},
	computed: {
		moduloCompatibilidade() {
			return this.$epecaHubB2c.featuresJson.COMPATIBILIDADE
		},
		autenticado() {
			return this.$store.getters["autenticado"]
		},
		formasPagamentoText() {
			return this.$epecaHubB2c.configJson.FORMAS_PAGAMENTO_TEXTO
		},
		banners() {
			return this.$store.state.bannerJson
		},
		...mapGetters(["featuresJson"]),
		getTotalOfAvailablePhotos() {
			const photos360 = this.produto.fotos.fotos_360.length > 0 ? 1 : 0
			return this.produto.fotos.fotos_avulsas.length + photos360 + this.produto.fotos.fotos_crop.length
		},
		multiplasConcessionarias() {
			return this.$epecaHubB2c.featuresJson.MULTI_CONC
		},
		fotos360HelperIndex() {
			if (this.produto.fotos.fotos_360.length > 0) {
				return 1
			}
			return 0
		},
		banners() {
			return this.$store.state.bannerJson
		},
		isClone() {
			return this.$epecaHubB2c.configJson.IS_CLONE
		},
		quantidadeProdutosAdicionados() {
			return this.$store.getters["Carrinho/quantidadeProdutosAdicionados"]
		},
		price() {
			if (this.checkPriority.uf === this.geolocation.uf) {
				return this.checkPriority.preco_desconto
			}
			return this.checkPriority.preco_majorado
		},
		possuiPrecoRange() {
			if (this.productWithStock) {
				return true
			}
		},
		productWithStock() {
			if (this.produto.qtde_lojas > 0) {
				return true
			}
			return false
		},
		solicitarCotacao() {
			if (!this.productWithStock) {
				return true
			}
			return false
		},
		hasSizes() {
			if (this.tamanhos && this.tamanhos.length > 0) {
				return true
			} else {
				return false
			}
		},
		configJson() {
			return this.$epecaHubB2c.configJson
		},
		selecionouCidade() {
			return this.$store.getters["selecionouCidade"]
		},
		hasDefaultStoreId() {
			if (this.configJson.DEFAULT_STORE_ID) {
				return this.configJson.DEFAULT_STORE_ID.split(",")
			}
		},
		availableStores() {
			return this.$store.getters["availableStores"]
		},
		checkPriority() {
			if (this.availableStores) {
				return checkProductAvailability(this.produto, this.availableStores)
			} else {
				return checkProductAvailability(this.produto, false)
			}
		},
		fullPath() {
			return this.$route.fullPath
		},
		baseUrl() {
			const concessionariaSelecionada = this.$store.getters["concessionariaSelecionada"]

			return concessionariaSelecionada.url
		},
		cep() {
			return this.$store.getters["cep"]
		},
		cidadeSelecionada() {
			return this.$store.getters["cidadeSelecionada"]
		},

		codigosOriginais() {
			return this.produto.codigosoriginais.join(", ")
		},
		concessionariaSelecionada() {
			return this.$store.getters["concessionariaSelecionada"]
		},
		featuresJson() {
			let ret = {}

			if (this.$epecaHubB2c) {
				ret = this.$epecaHubB2c.featuresJson
			}

			return ret
		},

		fotoPrincipal() {
			return this.produto.fotos.fotos_360[0] || this.produto.fotos.fotos_avulsas[0] || this.produto.fotos.fotos_crop[0] || null
		},
		metaDescription() {
			return this.produto.seo_title
		},
		fotos() {
			return this.produto.fotos
		},
		maximoParcelas() {
			if (this.formasPagamento.length > 0) {
				try {
					return Math.max(...this.formasPagamento.map((item) => item.maximoParcelas))
				} catch (error) {
					return false
				}
			} else {
				return false
			}
		},
		possuiTamanhos() {
			let ret = false

			if (this.produto.INFO_BOUTIQUE) {
				if (this.produto.INFO_BOUTIQUE.length > 0) {
					if (this.produto.INFO_BOUTIQUE[0].tamanho !== "unico") {
						ret = true
					}
				}
			}

			return ret
		},
		isBoutique() {
			if (this.produto.segmento === "Boutique") {
				return true
			}
			return false
		},
		segmentoBoutique() {
			const segmentoProduto = this.segmentoProduto

			let ret = false

			if (this.segmentoProduto) {
				if (segmentoProduto.toLowerCase() === "boutique") {
					ret = true
				}
			}

			return ret
		},

		segmentoProduto() {
			return this.produto.str_segmento
		},

		tamanhosProduto() {
			let ret = []

			if (this.produto.INFO_BOUTIQUE) {
				const infoBoutique = this.produto.INFO_BOUTIQUE

				infoBoutique.forEach((item, index, array) => {
					ret.push(item)
				})
			}

			return ret
		},
		mostrarPreco() {
			return this.$store.getters["mostrarPreco"]
		},
	},
	methods: {
		upperCaseChassi() {
			this.chassi = this.chassi.toUpperCase()
		},
		async buscaRespostasChassi() {
			const codigo_original = this.produto.codigo_original

			try {
				const res = await this.$axios.get(`${API_B2C_BACKEND}/produto/compatibilidade/chassi?codigo_original=${codigo_original}`)
				this.listaPerguntas = res.data.data
			} catch (error) {
				console.log(error)
			}
		},
		tryRefine(query) {
			let trimQuery = query.trim()
			this.$store.dispatch("setLastSearch", trimQuery)
			this.$router.push({ path: "/lista/", query: { query: trimQuery } })
		},
		triggerWhatsapp() {
			if (process.env.TOKEN_EPA) {
				let $epa = new window._epa({
					cKey: process.env.TOKEN_EPA,
				})

				$epa.send("duvida-aplicacao")
			}
		},
		triggerSolicitarCotacao() {
			this.modalSolicitarCotacaoVisibility = false
		},
		async carouselProdutosDestaque() {
			const searchClient = algoliasearch(this.$epecaHubB2c.configJson.ALGOLIA_APPLICATION_ID, this.$epecaHubB2c.configJson.ALGOLIA_API_KEY_READ_ONLY)
			const indexNameProdutos = process.env.ALGOLIA_INDEX_PRODUCTS
			const indexProdutos = searchClient.initIndex(indexNameProdutos)
			let itensRelacionados = this.relacionados

			const produtoAlgolia = await carregarProdutoPorId(itensRelacionados, indexProdutos, this.availableStores)
			const listaProdutosDestaque = produtoAlgolia.hits

			return listaProdutosDestaque
		},
		linkCardProdutoClick(e, produto, produtoIndex) {
			return
		},
		productUrl(product) {
			return getProductUrl(product)
		},
		srcImagem(product) {
			const fotos = product.fotos
			let ret = ""
			let fotos360 = fotos.fotos_360
			let fotosCrop = fotos.fotos_crop
			let fotosAvulsas = fotos.fotos_avulsas
			let imgUrl = `${this.$epecaHubB2c.configJson.CDN_IMAGES_RESIZE}/300x300/`
			if (fotos360.length > 0) {
				imgUrl += fotos360[0]
			} else if (fotosAvulsas.length > 0) {
				imgUrl += fotosAvulsas[0]
			} else if (fotosCrop.length > 0) {
				imgUrl += fotosCrop[0]
			} else {
				imgUrl = "/custom/epeca/assets/img/icone-sem-foto.svg"
			}
			ret = imgUrl
			return ret
		},
		changeSlide(index) {
			this.$nextTick(() => {
				this.glide.go(`=${index}`)
			})
		},
		getStockText(quantity) {
			return getDealershipsText(quantity)
		},
		changeCEP() {
			this.freteValue = ""
			this.fretes = []
		},
		zoom(e) {
			this.$nextTick(() => {
				let zoomer = e.currentTarget
				if (e.offsetX > 0 && e.offsetY > 0) {
					let offsetX = null
					let offsetY = null
					e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX)
					e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX)
					let x = (offsetX / zoomer.offsetWidth) * 100
					let y = (offsetY / zoomer.offsetHeight) * 100
					zoomer.style.backgroundPosition = x + "% " + y + "%"
				}
			})
		},
		handlerContextMenu(e) {
			e.preventDefault()
		},
		updateCepRules() {
			this.geolocation = this.$storage.getUniversal("geolocation")
			this.freteValue = this.cep
			this.getDealershipInfo(this.checkPriority.id_loja)
		},
		resetFrete() {
			this.freteValue = null
			this.fretes = []
			this.errorFrete = ""
		},
		badgeText(stockAvailable) {
			return getBadgeText(stockAvailable)
		},
		async getDealershipInfo(storeId) {
			const searchClient = algoliasearch(this.$epecaHubB2c.configJson.ALGOLIA_APPLICATION_ID, this.$epecaHubB2c.configJson.ALGOLIA_API_KEY_READ_ONLY)
			const index = "info_dealerships"

			const algoliaIndex = searchClient.initIndex(index)
			// Busca os dados da concessionaria pelo getObject
			const res = await algoliaIndex.getObject(String(storeId))

			this.dadosConcessionariaAtiva = res
			const dealerShipLatitude = res.lat
			const dealerShipLongitude = res.lon

			if (this.geolocation) {
				let userGeolocation = this.geolocation

				if (userGeolocation) {
					const distance = getDistance(
						{
							latitude: userGeolocation.latitude,
							longitude: userGeolocation.longitude,
						},
						{
							latitude: dealerShipLatitude,
							longitude: dealerShipLongitude,
						}
					)

					this.activeDealershipDistance = distance
				}
			}
		},
		async getDealershipByQuery(storeId) {
			const searchClient = algoliasearch(this.$epecaHubB2c.configJson.ALGOLIA_APPLICATION_ID, this.$epecaHubB2c.configJson.ALGOLIA_API_KEY_READ_ONLY)
			const index = "info_dealerships"
			const algoliaIndex = searchClient.initIndex(index)
			const res = await algoliaIndex.search("", {
				facetFilters: `objectID:${storeId}`,
			})
			if (res.hits.length > 0) {
				let cep = res.hits[0].cep_origem
				try {
					const data = await this.$axios.post(API_B2C_BACKEND + `/geolocalizacao?token=${TOKEN_EPA}`, {
						cep: cep,
					})
					return data.data.data
				} catch (error) {
					console.log(error)
				}
			}
			return
		},
		async changeDealership(dealershipId) {
			// Set default prices
			let newOrder = this.availableStores

			newOrder.forEach(function (item, i) {
				if (item == dealershipId) {
					newOrder.splice(i, 1)
					newOrder.unshift(item)
				}
			})

			setAvailableStores(newOrder)

			const searchClient = algoliasearch(this.$epecaHubB2c.configJson.ALGOLIA_APPLICATION_ID, this.$epecaHubB2c.configJson.ALGOLIA_API_KEY_READ_ONLY)
			const indexNameProdutos = process.env.ALGOLIA_INDEX_PRODUCTS

			const indexProdutos = searchClient.initIndex(indexNameProdutos)
			const routePath = this.$route.path
			const idProdutoRoute = routePath.replace("/produto/", "").split("/")[0]
			const productId = getLastPath(routePath) || idProdutoRoute

			const produtoAlgolia = await carregarProduto(productId, indexProdutos, newOrder)
			this.produto = produtoAlgolia
			this.getDealershipInfo(this.checkPriority.id_loja)

			this.modalVisibility = !this.modalVisibility
			this.dealerships = []
			this.dealershipError = ""
			this.fretes = []
			this.errorFrete = ""

			if (this.cidadeSelecionada && !this.solicitarCotacao) {
				this.loadPaymentOptions()
			}

			this.changeDealerTooltip = !this.changeDealerTooltip
			setTimeout(() => {
				this.changeDealerTooltip = !this.changeDealerTooltip
			}, 4500)
		},
		changeFilter(filter) {
			this.dealershipError = ""
			this.dealerships = []
			this.dealershipFilter = filter
			const obj = {
				cep: this.cep,
				cidade: this.cidadeSelecionada,
				filtro: this.dealershipFilter,
				id_produto_variacao: this.produto.id_produto_variacao,
				registros_limite: 4,
			}

			this.carregarConcessionarias(obj)
		},
		closeModalLimit() {
			this.modalLimitVisibility = !this.modalLimitVisibility
		},
		closeModal() {
			this.modalVisibility = !this.modalVisibility
			this.dealerships = []
			this.dealershipError = ""
		},
		havePriceFromAlgolia() {
			if (Object.keys(this.checkPriority.length !== 0)) {
				return true
			}
		},
		triggerGtmEvent() {
			this.$gtmHelpers.sendEvent.withProducts({
				event: "productDetail",
				products: {
					lists: {
						listaProdutos: [this.produto],
					},
				},
				pagePath: this.$route.fullPath,
				pageType: "produto",
			})
		},
		triggerEpaEvent() {
			let productPrice = this.checkPriority.preco_desconto
			let itemDetails = {
				item_id: this.produto.id_produto_variacao,
				item_name: this.produto.descricao,
				coupon: "",
				discount: 0,
				item_brand: "",
				item_category: "",
				item_variant: "",
				price: productPrice,
				currency: "BRL",
				quantity: 1,
			}
		},
		setSize(id) {
			this.produto = this.produtos.find((s) => s.id_produto_variacao === id)
		},
		abrirModalSolicitarCotacao() {
			this.modalSolicitarCotacaoVisibility = true
		},
		isVariation() {
			if (this.hasSizes) {
				return true
			} else {
				return false
			}
		},
		async calcularFrete(cep) {
			let productId = this.produto.id_produto
			let vm = this
			if (this.isVariation) {
				productId = this.produto.id_produto_variacao
			}

			let storeId = this.checkPriority.id_loja

			this.loadingFrete = true
			this.fretes = []
			this.errorFrete = ""

			let API_B2C_BACKEND = process.env.API_B2C_BACKEND

			try {
				const res = await this.$axios.post(API_B2C_BACKEND + `/frete/v3?token=${TOKEN_EPA}`, {
					cep_destino: cep,
					url: window.location.href,
					produtos: [
						{
							id: this.produto.id_produto,
							id_produto_variacao: productId,
							preco_final: this.checkPriority.preco_desconto,
							quantidade: 1,
							codigosoriginais: this.produto.codigosoriginais,
							id_loja: storeId,
						},
					],
				})

				if (!res.data.ERROR) {
					this.fretes = res.data.data[0].frete

					if (process.env.TOKEN_EPA) {
						let $epa = new window._epa({
							cKey: process.env.TOKEN_EPA,
						})

						$epa.send("calcular-frete", {
							cep: cep,
							fretes: this.fretes,
						})
					}
				} else {
					this.errorFrete = res.data.message.content
				}
			} catch (error) {
				if (process.env.TOKEN_EPA) {
					let $epa = new window._epa({
						cKey: process.env.TOKEN_EPA,
					})

					$epa.send("erro-calcular-frete", {
						cep: cep,
						erro: error.response.data.message,
					})
				}

				this.loadingFrete = false
				this.errorFrete = error.response.data.message
			}

			this.loadingFrete = false
		},
		buscarFrete() {
			this.frete.detalhes = []
			this.frete.carregando = true
			this.frete.erro = false

			let productId = this.produto.id_produto
			if (this.isVariation) {
				productId = this.produto.id_produto_variacao
			}

			let API_B2C_BACKEND = process.env.API_B2C_BACKEND

			this.$axios
				.post(API_B2C_BACKEND + `/frete/v3?token=${TOKEN_EPA}`, {
					cep_destino: this.frete.model.cep,
					url: window.location.href,
					produtos: [
						{
							id: this.produto.id_produto,
							id_produto_variacao: productId,
							preco_final: this.checkPriority.preco_desconto,
							quantidade: 1,
							codigosoriginais: this.produto.codigosoriginais,
							id_loja: this.checkPriority.id_loja,
						},
					],
				})
				.then((response) => {
					const data = response.data

					let gtmEventLabelRetorno = null

					if (data.ERROR) {
						if (data.data === "CEP_BLOQUEADO") {
							this.frete.erro = true
							this.frete.mensagem = data.message

							gtmEventLabelRetorno = "cep-bloqueado"
						} else if (data.data === "CEP_INVALIDO") {
							this.frete.erro = true
							this.frete.mensagem = data.message

							gtmEventLabelRetorno = "cep-invalido"
						} else {
							this.frete.erro = true
							this.frete.mensagem = null

							gtmEventLabelRetorno = "erro-generico"
						}
					} else {
						this.frete.erro = false
						this.frete.detalhes = data.data[0].frete

						gtmEventLabelRetorno = "sucesso"
					}

					this.$gtmHelpers.sendEvent.basic({
						event: "sendEvent",
						eventAction: "form:submit",
						eventLabel: `calculo-frete:${gtmEventLabelRetorno}`,
					})
				})
				.catch((error) => {
					this.frete.erro = true
				})
				.then(() => {
					this.frete.carregando = false
				})
		},

		async carregarConcessionarias(obj) {
			if (this.featuresJson.SELLER && this.featuresJson.STORE_SELECT) {
				this.concessionarias.data = [
					{
						id: "-",
						cep: null,
						email: null,
						endereco: null,
						logo: null,
						telefone: null,
						url: null,
						nome: "-",
						distancia: "-",
						valor_item: 0,
						valor_frete: 0,
						valor_total: 0,
						prazo_entrega: "-",
					},
				]
				try {
					this.loadingDealerships = true
					let filterConc = this.geolocation.codigo_ibge || obj.cep

					const res = await this.$helpers.getFiltroConcessionaria(filterConc, obj.id_produto_variacao, obj.filtro, this)
					this.concessionarias.data = res.data.data
					this.dealerships = res.data.data
				} catch (error) {
					this.dealershipError = error.response.data.message
				}
				this.loadingDealerships = false
			}
		},

		async loadPaymentOptions() {
			try {
				const storeId = this.checkPriority.id_loja
				const productId = this.checkPriority.id_produto
				const res = await this.$axios.get(API_B2C_BACKEND + `/forma_pagamento/loja/${storeId}/produto/${productId}?token=${TOKEN_EPA}`)
				const data = res.data.data

				this.parcelaData = data
			} catch (error) {
				console.log(error)
			}
		},
		getImgSrc(imgUrl, dimensao = "900x900") {
			let ret = "/custom/epeca/assets/img/icone-sem-foto.svg"

			if (imgUrl) {
				ret = `${this.$epecaHubB2c.configJson.CDN_IMAGES_RESIZE}/${dimensao}/${imgUrl}`
			}

			return ret
		},
		mountTitle() {
			try {
				return this.productName + " | Loja Virtual"
			} catch (err) {
				console.log(err)
			}
		},

		mountMetaDescription() {
			try {
				return this.metaDescription
			} catch (err) {
				console.log(err)
			}
		},
		botaoComprarClick(adicionarAoCarrinho) {
			if (this.selecionouCidade) {
				if (adicionarAoCarrinho) {
					this.notificationTooltip = true

					if (process.env.TOKEN_EPA) {
						let $epa = new window._epa({
							cKey: process.env.TOKEN_EPA,
						})

						$epa.send("adicionar-carrinho-com-localizacao")
					}

					let objectIds = this.produto.objectID
					let userToken = this.$cookies.get("_ALGOLIA")
					let queryID = this.queryID

					window.aa("convertedObjectIDs", {
						userToken: userToken,
						index: this.indexNameProdutos,
						eventName: "Product Added to Cart by Add Button",
						objectIDs: [objectIds],
						queryID: queryID,
					})
				} else {
					if (process.env.TOKEN_EPA) {
						let $epa = new window._epa({
							cKey: process.env.TOKEN_EPA,
						})

						$epa.send("comprar-com-localizacao")
					}

					let objectIds = this.produto.objectID
					let userToken = this.$cookies.get("_ALGOLIA")
					let queryID = this.queryID

					window.aa("convertedObjectIDs", {
						userToken: userToken,
						index: this.indexNameProdutos,
						eventName: "Product Added to Cart by Buy Button",
						objectIDs: [objectIds],
						queryID: queryID,
					})
				}

				if (process.client) {
					if (this.price) {
						this.$store.dispatch("comprar", {
							featuresJson: this.$epecaHubB2c.featuresJson,
							precoEstoque: this.price,
							produto: this.produto,
							idLoja: this.checkPriority.id_loja,
							route: this.$nuxt.$route,
							vm: this,
							adicionarAoCarrinho: adicionarAoCarrinho,
							productDetails: this.checkPriority,
						})
					} else {
						this.$forceUpdate()
					}
				}
			} else {
				if (adicionarAoCarrinho) {
					if (process.env.TOKEN_EPA) {
						let $epa = new window._epa({
							cKey: process.env.TOKEN_EPA,
						})

						$epa.send("adicionar-carrinho-sem-localizacao")
					}
				} else {
					if (process.env.TOKEN_EPA) {
						let $epa = new window._epa({
							cKey: process.env.TOKEN_EPA,
						})

						$epa.send("comprar-sem-localizacao")
					}
				}
				this.$eventbus.$emit("ComponentMinhaLocalizacao/abrir", {
					callback: async () => {
						if (this.price) {
							this.$store.dispatch("comprar", {
								featuresJson: this.$epecaHubB2c.featuresJson,
								precoEstoque: this.price,
								produto: this.produto,
								idLoja: this.checkPriority.id_loja,
								route: this.$nuxt.$route,
								vm: this,
								adicionarAoCarrinho: adicionarAoCarrinho,
								productDetails: this.checkPriority,
							})
						} else {
							this.$forceUpdate()
						}
					},
				})
			}
		},
		botaoFornecidoPorEscolherOutraConcessionariaClick(e) {
			if (process.env.TOKEN_EPA) {
				let $epa = new window._epa({
					cKey: process.env.TOKEN_EPA,
				})

				$epa.send("filtrar-lojas")
			}

			const obj = {
				cep: this.cep,
				cidade: this.cidadeSelecionada,
				filtro: this.dealershipFilter,
				id_produto_variacao: this.produto.id_produto_variacao,
				registros_limite: 4,
			}

			this.carregarConcessionarias(obj)
			this.modalVisibility = !this.modalVisibility
		},
		botaoFornecidoPorInformeOCepClick(e) {
			if (process.env.TOKEN_EPA) {
				let $epa = new window._epa({
					cKey: process.env.TOKEN_EPA,
				})

				$epa.send("localize-me")
			}

			this.$eventbus.$emit("ComponentMinhaLocalizacao/abrir", {
				callback: async () => {},
			})
		},
		iconeArrowDownClick(e) {
			window.scrollTo({
				top: 560,
				left: 0,
				behavior: "smooth",
			})
		},
		calculateShipping(value) {
			this.calcularFrete(value)
		},
	},
	head() {
		let head = {}

		head.meta = [
			{
				hid: "description",
				name: "description",
				content: this.mountMetaDescription(),
			},
			{ property: "og:description", content: this.mountMetaDescription() },
		]

		if (process.env.baseUrl) {
			let baseUrl = process.env.baseUrl
			let fullPath = this.$nuxt.$router.currentRoute.fullPath

			let link = [
				{ rel: "canonical", href: `${baseUrl}${fullPath}` },
				{ rel: "alternate", href: `${baseUrl}${fullPath}`, hreflang: "pt-br" },
			]
			head.link = link

			head.meta.push({
				property: "og:url",
				content: `${baseUrl}${fullPath}`,
			})

			let urlImage = this.getImgSrc(this.fotoPrincipal)
			head.meta.push({ property: "og:image", content: `${urlImage}` })
		}
		head.title = this.mountTitle()

		head.script = [{ type: "application/ld+json", json: this.structuredData }]

		head.meta = [...head.meta, ...this.metaProdutos]

		return head
	},
	watchQuery: ["pagina"],
	destroyed() {
		const defaultAvailableStores = localStorage.getItem("epeca-hub-b2c/availableStores")

		if (defaultAvailableStores) {
			let arrAvailableStores = defaultAvailableStores.split(",")
			this.$store.dispatch("setStoreIds", arrAvailableStores)
		}
	},
	watch: {
		quantidadeProdutosAdicionados() {
			if (this.quantidadeProdutosAdicionados === 15) {
				this.modalLimitVisibility = true
				this.limitCart = true
			}
		},
		cep: {
			immediate: true,
			handler(value, oldValue) {
				this.updateCepRules()
				if (oldValue) {
					this.fretes = []
					this.errorFrete = ""
				}

				if (value) {
					if (!this.solicitarCotacao) {
						this.loadPaymentOptions()
					}
				}
			},
		},
		selecionouCidade: {
			immediate: false,
			handler(value) {
				// Se tiver location selecionado, busca da store
				if (value) {
					if (Object.keys(this.checkPriority).length !== 0) {
						this.getDealershipInfo(this.checkPriority.id_loja)
					}
					this.defaultStoreId = this.availableStores
					this.freteValue = this.cep

					this.tamanhos = getProductSizes(this.availableStores, this.produtos)
				} else {
					// Tem default store Id
					if (this.configJson.DEFAULT_STORE_ID && !this.isClone) {
						let idsFromJson = this.configJson.DEFAULT_STORE_ID.split(",")
						this.$store.dispatch("setStoreIds", idsFromJson)
					}
					this.tamanhos = []
					this.resetFrete()
				}
			},
		},
		produto(value, oldValue) {
			const tamanhoSelecionado = this.tamanhoSelecionado

			if (tamanhoSelecionado) {
				this.tamanhoSelecionado = tamanhoSelecionado
			} else {
				this.tamanhoSelecionado = this.tamanhosProduto[0]
			}
		},

		tamanhosProduto(value, oldValue) {
			if (value) {
				if (value.length > 0) {
					for (let i = 0; i < value.length; i++) {
						if (value[i].estoque > 0) {
							this.tamanhoSelecionado = value[i]

							break
						}
					}
				}
			}
		},
	},
	created() {
		if (process.client) {
			window.addEventListener("scroll", (e) => {
				if (window.innerHeight < 680) {
					if (window.scrollY > 0) {
						this.mostrarArrowDown = false
					} else {
						this.mostrarArrowDown = true
					}
				}
			})
		}
	},
	async mounted() {
		this.produtosRelacionados = await this.carouselProdutosDestaque()
		window.aa("init", {
			appId: "JPW9SFM280",
			apiKey: "921eed61ec24f8facc2b777b74bffb21",
			useCookie: true,
		})

		if (this.produto) {
			let userToken = this.$cookies.get("_ALGOLIA")
			let objectId = this.produto.objectID
			let queryID = this.queryID

			window.aa("viewedObjectIDs", {
				userToken: userToken,
				index: ALGOLIA_INDEX_PRODUCTS,
				eventName: "Product Viewed",
				queryID: queryID,
				objectIDs: [objectId],
			})
		}

		this.$nextTick(() => {
			this.glide = new Glide(".glide-product", {
				type: "carousel",
				perView: 1,
				swipeThreshold: false,
				dragThreshold: false,
			}).mount({ Controls, Breakpoints, Swipe })
		})

		this.triggerGtmEvent()

		if (window.innerHeight < 680) {
			this.mostrarArrowDown = true
		} else {
			this.mostrarArrowDown = false
		}

		let idsCaouselVisitados = localStorage.getItem("carousel-produtos-visitados")
		let idsPreparadasEmArray = []
		if (idsCaouselVisitados) {
			idsCaouselVisitados = idsCaouselVisitados.split(",")
			idsCaouselVisitados.forEach(function (id) {
				idsPreparadasEmArray.push(parseInt(id))
			})

			idsPreparadasEmArray = idsPreparadasEmArray.length == 12 ? idsPreparadasEmArray.splice(1) : idsPreparadasEmArray
			let produtoJaFoiVisitado = idsPreparadasEmArray.find((id) => id == this.produto.id_produto)
			if (!produtoJaFoiVisitado) {
				idsPreparadasEmArray.push(this.produto.id_produto)
			}
			localStorage.setItem("carousel-produtos-visitados", idsPreparadasEmArray)
		} else {
			localStorage.setItem("carousel-produtos-visitados", [this.produto.id_produto])
		}

		if (this.$cookies.get("selectedCity")) {
			this.freteValue = this.cep
		}

		if (this.quantidadeProdutosAdicionados === 15) {
			this.modalLimitVisibility = true
			this.limitCart = true
		}

		let idLojaQuery = this.$route.query.loja
		if (idLojaQuery) {
			let dealerDetails = await this.getDealershipByQuery(idLojaQuery)
			if (dealerDetails) {
				let locationData = dealerDetails
				let lojasPrioritarias = locationData.lojas_prioritarias
				let cepLoja = locationData.cep
				let cidadeLoja = locationData.cidade
				if (lojasPrioritarias) {
					this.$store.dispatch("setStoreIds", lojasPrioritarias)
				}
				this.$storage.setUniversal("geolocation", locationData)
				this.$store.dispatch("definirCep", cepLoja)
				this.$store.dispatch("definirCidadeSelecionada", cidadeLoja)
			}
		}

		await this.buscaRespostasChassi()
	},
}
</script>

<style lang="scss">
.modal__cart {
	padding: 16px;
	.modal__btnclose {
		display: none !important;
	}
}
</style>

<style lang="scss" scoped>
.container-arrow-down {
	box-sizing: border-box;
	bottom: 0;
	left: 0;
	padding: 1em;
	position: fixed;
	text-align: center;
	width: 100%;
	animation-name: containerArrowDown;
	animation-duration: 1s;
	animation-iteration-count: infinite;
	animation-timing-function: ease-out;
	animation-direction: alternate;
}

.container-arrow-down img {
	cursor: pointer;
	display: inline-block;
	height: 2em;
}

@keyframes containerArrowDown {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}
.heart.active {
	path {
		fill: red;
	}
}
.container-grupo-foto-infos-produto {
	padding: 0 16px;
	display: flex;
	flex-direction: column;
	gap: 40px;
	@media (min-width: 1220px) {
		padding: 0;
		gap: 0;
		flex-direction: row;
	}
}
.img__carousel {
	margin: 0 auto;
	justify-content: center;
	img {
		border: 1px solid #c2c2c2;
	}
}
@media (min-width: 768px) {
	.img__carousel {
		display: flex;
		margin-bottom: 48px;
		gap: 24px;
	}
}
.product__leftside {
	@media (min-width: 1220px) {
		width: 764px;
	}
}
/** Zoom CSS */
figure.zoom {
	background-position: 50% 50%;
	position: relative;
	height: 100%;
	width: 100%;
	overflow: hidden;
}
figure.zoom img {
	transition: opacity 0.5s;
	display: block;
	width: 100%;
}
figure.zoom img:hover {
	opacity: 0;
}
@media (min-width: 560px) {
	figure.zoom {
		background-position: 50% 50%;
		position: relative;
		overflow: hidden;
	}
}
.glide-product {
	margin-top: 0;
	.glide__bullets {
		bottom: -30px;
	}
	.glide__bullet {
		background-color: #c2c2c2;
	}
	.glide__bullet--active {
		background-color: #535353;
	}
	.glide__bullet:hover,
	.glide__bullet:focus {
		border: none;
	}
	.glide__slides {
		li {
			position: relative;
		}
	}
	.glide__arrow {
		background-color: #fff;
		border: 1px solid #c2c2c2;
		i {
			color: #535353;
		}
		&--left {
			left: 16px;
		}
		&--right {
			right: 16px;
		}
	}
}
.icon__zoom {
	position: absolute;
	left: 16px;
	top: 16px;
	z-index: 999;
	.zoom-lupa {
		border: none;
	}
}

.product__name {
	font-size: 24px;
	line-height: 29px;
	margin-bottom: 8px;
	font-family: var(--head-bold);
	@media (max-width: 768px) {
		font-size: 20px;
		line-height: 24px;
	}
}
.product__application {
	font-size: 16px;
	line-height: 20px;
}
.wrapper-actions {
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 32px 0;
	border-bottom: 1px solid #c2c2c2;
	@media (min-width: 768px) {
		display: grid;
		gap: 8px;
		grid-template-columns: 1fr 1fr;
	}
}
.social-link {
	color: #3c484d;
	display: flex;
	align-items: center;
	grid-gap: 8px;
	gap: 8px;
	cursor: pointer;
	&.active {
		svg path {
			fill: red;
		}
	}
	@media (min-width: 768px) {
		font-size: 20px;
		line-height: 24px;
	}
}
.wrapper-infos {
	padding: 32px 0;
	display: flex;
	flex-direction: column;
	gap: 16px;
	border-bottom: 1px solid #c2c2c2;
	.info-box {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		padding: 8px;
		gap: 8px;
		background: #f1f1f1;
		border-radius: 4px;
		font-size: 16px;
		line-height: 20px;
		height: 40px;
		svg {
			height: 24px;
			width: 24px;
			@media (min-width: 768px) {
				height: initial;
				width: initial;
			}
		}
	}
}
.wrapper-extrainfos {
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 32px 0px 32px 0px;
	border-bottom: 1px solid #c2c2c2;
	h2 {
		font-size: 20px;
		line-height: 24px;
		display: flex;
		align-items: center;
	}
}
.wrapper-pagamento {
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 32px 0px 32px 0px;
	border-bottom: 1px solid #c2c2c2;
	@media (min-width: 1025px) {
		border-bottom: none;
	}
	h2 {
		font-size: 20px;
		line-height: 24px;
		display: flex;
		align-items: center;
	}
	p {
		padding: 0;
	}
	.parcelamento {
		font-size: 10px;
		line-height: 12px;
	}
}
.wrapper-smalltags {
	display: flex;
	justify-content: space-between;
}

.tag__small {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 4px 8px;
	gap: 4px;
	background: #c2c2c2;
	border-radius: 5px;
	font-size: 10px;
	line-height: 12px;
	display: flex;
	align-items: center;
	color: #4e4f50;
	text-align: center;
	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 15px;
	}
}
.descricao {
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 16px;
	background: #f1f1f1;
	border-radius: 10px;
	@media (min-width: 1220px) {
		margin: 0;
	}
	h3 {
		font-size: 16px;
		line-height: 20px;
		@media (min-width: 768px) {
			font-size: 24px;
			line-height: 1;
		}
	}
	p {
		padding: 0;
		font-size: 16px;
		line-height: 20px;
		color: #3c484d;
		font-family: var(--head-regular);
	}
}
.descricao-aplicacoes {
	max-height: 300px;
	overflow-y: scroll;
}
.wrapper-greyinfos {
	flex-direction: column;
	gap: 16px;
	padding: 32px 0;
	margin-top: 16px;
	@media (min-width: 1220px) {
		padding: 8px 0;
		margin-top: 0;
	}
}
.bloco-compra {
	display: flex;
	flex-direction: column;
	gap: 16px;
	@media (min-width: 1025px) {
		margin-top: 0;
	}
	@media (min-width: 1220px) {
		margin-top: 16px;
	}
}
.unidadevenda {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 4px 8px;
	background: #f1f1f1;
	border-radius: 5px;
	font-size: 12px;
	line-height: 15px;
	@media (min-width: 768px) {
		font-size: 16px;
		line-height: 20px;
	}
}
.breadcrumb__product {
	font-size: 12px;
	line-height: 15px;
}
.vendedor-info {
	padding: 32px 0;
	display: flex;
	flex-direction: column;
	gap: 16px;
	border-bottom: 1px solid #c2c2c2;
	h2 {
		font-size: 20px;
		line-height: 24px;
		display: flex;
		align-items: center;
		color: #4e4f50;
		@media (min-width: 768px) {
			font-size: 24px;
			line-height: 29px;
		}
	}
	.conc-name {
		font-size: 16px;
		line-height: 20px;
		color: #6f6f6f;
		@media (min-width: 768px) {
			font-size: 20px;
			line-height: 24px;
		}
	}
	.lojas-com-estoque {
		font-size: 16px;
		line-height: 20px;
		color: #6f6f6f;
		@media (min-width: 768px) {
			font-size: 16px;
			line-height: 20px;
		}
	}
	.ver-lojas {
		font-size: 10px;
		line-height: 12px;
		text-decoration-line: underline;
		color: #6f6f6f;
		cursor: pointer;
		@media (min-width: 768px) {
			font-size: 12px;
			line-height: 15px;
		}
	}
}
.product__info {
	display: flex;
	flex-direction: column;
}
.applications__text {
	font-size: 20px;
	color: #6f6f6f;
	line-height: 24px;
}
.glide__wrapper {
	max-width: 540px;
	@media (min-width: 1220px) {
		width: 560px;
	}
}
.glide-vertical {
	flex-direction: column;
	gap: 16px;
	max-width: 196px;
	max-height: 600px;
	overflow: auto;
	.vertical__box {
		height: 100px;
		width: 100px;
		cursor: pointer;
		img {
			max-width: 100%;
		}
	}
}
.glide-vertical {
	-ms-overflow-style: none; /* Internet Explorer 10+ */
	scrollbar-width: none; /* Firefox */
}
.glide-vertical::-webkit-scrollbar {
	display: none; /* Safari and Chrome */
}
.box-flutuante {
	left: 0;
	bottom: 0;
	background-color: #fff;
	padding: 16px;
	width: 100%;
	box-shadow: 8px 0px 12px rgba(0, 0, 0, 0.33);
	z-index: 8;
	flex-direction: column;
	@media (min-width: 1220px) {
		display: none;
	}
	.wrapper-actions {
		flex-direction: row;
		padding: 0;
		border-bottom: 0;
		margin-top: 8px;
	}
	.btn__primary--outline,
	.btn__primary {
		padding: 8px 16px;
		font-size: 12px;
		line-height: 15px;
		svg {
			display: none;
		}
	}
}
.glide__slide {
	padding: 24px;
	border: 1px solid #f1f1f1;
	border-radius: 10px;

	cursor: pointer;
	&:hover {
		border: 1px solid var(--primary_color);
	}
	@media (min-width: 1200px) {
		padding: 24px 27px 48px;
		border: 1px solid #f1f1f1;
		border-radius: 10px;
	}
}
.glide__slide__img {
	width: 200px;
	height: 200px;
	margin: 0 auto 8px;
	background-size: cover;
	border: 1px solid #f1f1f1;
	position: relative;
	@media (min-width: 1200px) {
		width: 224px;
		height: 224px;
		margin-bottom: 16px;
	}
}
.glide__slide__desc {
	font-size: 16px;
	line-height: 20px;
}
.glide__slide__subtitle {
	font-size: 16px;
	line-height: 20px;
	margin-top: 8px;
}
.glide__slide__infos {
	display: flex;
	flex-direction: column;
	min-height: 80px;
}
.socialshare {
	display: flex;
	gap: 16px;
}
.container-grupo-foto-infos-produto {
	padding: 0 16px;
	@media (min-width: 1220px) {
		display: flex;
		gap: 32px;
		padding: 0;
		grid-template-columns: 648px auto;
	}
}
.product__rightside {
	@media (min-width: 1220px) {
		background: #ffffff;
		width: 100%;
	}
}
.glide-vertical {
	display: none;
	@media (min-width: 1220px) {
		display: flex;
	}
}
.section__top {
	margin-bottom: 32px;
	@media (min-width: 1025px) {
		margin-bottom: 0;
	}
}
.banner {
	margin-bottom: 32px;
}
.banner-mobile {
	display: block;
	@media (min-width: 400px) {
		display: none;
	}
}
.banner-desktop {
	display: none;
	@media (min-width: 400px) {
		display: block;
	}
}
.relacionados {
	display: none;
	@media (min-width: 768px) {
		grid-template-columns: 1fr 1fr 1fr;
		gap: 16px;
		display: grid;
	}
}
.lupa-busca {
	position: absolute;
	right: 1rem;
	top: 50%;
	margin-top: -13px;
}
.wrapper-badges {
	display: flex;
	flex-direction: column;
	gap: 8px;
	@media (min-width: 1220px) {
		grid-template-columns: 1fr 1fr 1.5fr;
		display: grid;
		margin: 0;
		gap: 8px;
	}
}
.compatibilidade {
	border-radius: 8px;
	background: var(--vw-grey-100, #dfe4e8);
	font-size: 12px;
	color: #3c484d;
	@media (min-width: 1220px) {
		font-size: 20px;
		align-items: center;
		padding: 12px 24px;
		border-radius: 50px;
		height: 64px;
		justify-content: space-between;
		margin-top: 0;
	}
	button {
		height: 39px;
	}
}
.input__ds {
	font-family: var(--text-regular);
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 22px 16px 8px 16px;
	background: #f1f1f1;
	border: 1px solid #c2c2c2;
	border-radius: 4px 4px 0px 0px;
	font-weight: 500;
	font-size: 16px;
	line-height: 19px;
	height: 49px;
	color: #000000;
	&.danger {
		border: 1px solid red;
		padding: 22px 16px 8px 16px;
	}
	&::placeholder {
		color: #c6cad1;
	}
}
.inputlabel__ds {
	position: absolute;
	top: 8px;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	color: #6f6f6f;
	left: 16px;
}
.danger {
	color: #c00;
	padding: 4px 16px 0;
}
.requireddot {
	color: #c00;
	font-size: 2em;
	line-height: 0;
	margin-left: 0.15em;
	vertical-align: sub;
}
.titulo-modal {
	font-size: 20px;
	color: #3c484d;
}
.desc-modal {
	font-size: 16px;
	color: #3c484d;
}
h3 {
	font-size: 16px;
	@media (min-width: 1220px) {
		font-size: 24px;
	}
}
.text-box {
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
	margin-bottom: 16px;
	&:last-of-type {
		margin-bottom: 0;
	}
}
.lista-perguntas {
	height: 300px;
	padding: 1px;
	overflow-y: scroll;
}
.super-small-font {
	font-size: 10px;
	color: #3c484d;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	@media (min-width: 768px) {
		font-size: 14px;
	}
}
.border-blue-600 {
	border-color: #ff6600;
}
</style>
